/**
 * @enum WinDirection - Type of win direction.
 */
export enum WinDirection {
    /**
     * @member right - win from right side
     */
    Right = <any>'right',

    /**
     * @member left - win from left side
     */
    Left = <any>'left'
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/WinDirection.ts
 **/